<template>
  <div class="carouselOne position-relative">

    <div class="col-md-11 col-12 carouselContainer">
      <carousel :nav="false" :items=1 :stagePadding=20 :center=true  v-if="!mobile_component" class="carouselOne-container">

        <nastere-naturala></nastere-naturala>

        <alaptarea></alaptarea>

        <expunerea></expunerea>

        <vaccinare></vaccinare>

<!--        <template #customPaging>-->
<!--          <div class="custom-dot">-->
<!--            &lt;!&ndash; {{ page }} &ndash;&gt;-->
<!--          </div>-->
<!--        </template>-->

      </carousel>
      <div v-else-if="mobile_component">

        <nastere-naturala></nastere-naturala>

        <alaptarea></alaptarea>

        <expunerea></expunerea>

        <vaccinare></vaccinare>

        <!--        <template #customPaging>-->
        <!--          <div class="custom-dot">-->
        <!--            &lt;!&ndash; {{ page }} &ndash;&gt;-->
        <!--          </div>-->
        <!--        </template>-->

      </div>
    </div>

  </div>
</template>

<script>

// import cards
import NastereNaturala from './CardSlick1/NastereNaturala.vue'
import Alapatarea from './CardSlick1/Alapatarea.vue'
import Expunerea from './CardSlick1/Expunerea.vue'
import Vaccinare from './CardSlick1/Vaccinare.vue'


import carousel from 'vue-owl-carousel'
export default {
  name: 'MyComponent',
  components: {
    carousel,

    // cards
    'nastere-naturala': NastereNaturala,
    'alaptarea': Alapatarea,
    'expunerea': Expunerea,
    'vaccinare': Vaccinare,
  },
  props: ["mobile_component"],
  data() {
    return {
      settings: {
        "dots": true,
        "infinite": false,
        "edgeFriction": 0.35,
        "speed": 500,
        "slidesToShow": 1.2,
        "slidesToScroll": 1,
        "initialSlide": 0,

      }
    }
  },
}
</script>

<style scoped lang="scss">
.carouselOne-container{
  margin-top: 20px;
}
.carouselOne {
  overflow: hidden;
  min-height: 300px;


  .carouselContainer {
    position: absolute;
    overflow: hidden;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    padding: 0;

    .slick-slider {
      ::v-deep .slick-dots {
        width: inherit;
        right: 25px;

        li {
          margin: 0;
          width: initial;
        }
      }
    }

    .slick-list {
      background-color: red;
      margin: 0 -150px 0 0;

      .slick-slide {
        display: block;
        margin-right: 30px;

        .bk-blue-light {
          background: #F2F0ED;
          border-radius: 20px;
          width: 400px !important;
          min-height: 200px;
          max-height: 200px;
          position: relative;
          @media only screen and (max-width: 768px) {
            width: 100% !important;
            min-height: 100%;
            max-height: 100%;
            margin-top: 15px;
          }

          &:focus {
            outline: none;
          }

          h3 {
            font-size: 20px;
            font-weight: 700;
            color: #029FE3;
          }

          p {
            font-size: 14px;
            font-weight: 500;
            color: #029FE3;
          }

          span {
            font-size: 16px;
            font-weight: 500;
            color: #029FE3;
          }
        }

      }
    }
  }
}

ul {
  .custom-dot {
    display: inline-block;
    font-size: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: none;
    background: #029FE3;
    outline: none;
    transition: all 0.2s ease;
    margin-right: 12px;
    cursor: pointer;
    opacity: 0.5;

  }

  .slick-active {
    .custom-dot {
      opacity: 1;
      width: 24px;
      border-radius: 10px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .carouselOne {
    margin-top: 0;

    ::v-deep .slick-slide {
      float: none !important;
    }
  }
}

@media only screen and (max-width: 475px) {

}

@media only screen and (max-width: 360px) {

}
</style>
